/**
 * 请求超时时间
 */
export const REQUEST_TIMEOUT = 5 * 60 * 1000

/**
 * 是否根据headers->content-type自动转换数据格式
 */
// export const TRANSFORM_REQUEST_DATA = true

// token key
export const TOKEN_KEY = 'Authorization'

// 默认的用户头像
export const DEFAULT_USER_AVATAR = new URL('@/assets/img/user_avatar_2x.png', import.meta.url).href
